<template>
  <v-carousel height="100%" cycle show-arrows-on-hover interval="3000">
    <v-carousel-item v-for="(item, i) in items" :key="i">
      <center>
        <v-img :src="require(`../assets/images/${veiculo}/${i + 1}.jpg`)" />
        <!-- <ImageBase64 :image="item" width="350" /> -->
      </center>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: "Carousel",

  props: {
    veiculo: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      items: 0
    }
  },

  mounted() {
    if (this.veiculo === 'biz110i') {
      this.items = 3
    } else if(this.veiculo === 'biz125') {
      this.items = 4
    } else if(this.veiculo === 'cb500f') {
      this.items = 3
    } else if(this.veiculo === 'cb500x') {
      this.items = 3
    } else if(this.veiculo === 'cb650r') {
      this.items = 3
    } else if(this.veiculo === 'cb1000r') {
      this.items = 2
    } else if(this.veiculo === 'cbr650r') {
      this.items = 2
    } else if(this.veiculo === 'cb250ftwisterabs') {
      this.items = 1
    } else if(this.veiculo === 'cb250ftwistercbs') {
      this.items = 2
    } else if(this.veiculo === 'cg160fan') {
      this.items = 3
    } else if(this.veiculo === 'cg160start') {
      this.items = 3
    } else if(this.veiculo === 'cg160titan') {
      this.items = 3
    } else if(this.veiculo === 'crf250f') {
      this.items = 1
    } else if(this.veiculo === 'crf250f') {
      this.items = 1
    } else if(this.veiculo === 'crf1000lafricatwin') {
      this.items = 2
    } else if(this.veiculo === 'elite125') {
      this.items = 4
    } else if(this.veiculo === 'nc750x') {
      this.items = 3
    } else if(this.veiculo === 'nxr160brosesdd') {
      this.items = 3
    } else if(this.veiculo === 'pcx') {
      this.items = 4
    } else if(this.veiculo === 'pop110i') {
      this.items = 3
    } else if(this.veiculo === 'sh150i') {
      this.items = 3
    } else if(this.veiculo === 'trx420') {
      this.items = 1
    } else if(this.veiculo === 'xre190') {
      this.items = 2
    } else if(this.veiculo === 'xre300abs') {
      this.items = 2
    }
  }
};
</script>